import { getContext } from '@/context';
import { API_URL } from '@/consts/urls';

export const DEFAULT_AVATAR =
  'https://cdn190.picsart.com/232804661007900.png?to=fixed&r=100x100';

const USER_TIER_URL = `${API_URL}/guard/users/tier`;
const CREDITS_URL = `${API_URL}/guard/credits`;

export interface UserCreditsResponse {
  credits: number;
  addonCredits: number;
}

export interface UserTierResponse {
  id: string;
}

export const fetchUserCredits =
  async (): Promise<UserCreditsResponse | null> => {
    try {
      const response = await getContext().utils.api.fetch(CREDITS_URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });
      if (!response.ok) return null;
      const data = await response.json();
      if (data.status !== 'success') return null;
      return data.response;
    } catch {
      return null;
    }
  };

export const fetchUserTier = async (): Promise<UserTierResponse | null> => {
  try {
    const queryParams = new URLSearchParams({ invalidate_cache: '0' });
    const response = await getContext().utils.api.fetch(
      `${USER_TIER_URL}?${queryParams}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }
    );
    if (!response.ok) return null;
    const data = await response.json();
    const tierInfo = data.response || data.data || data;
    return { id: tierInfo.id };
  } catch {
    return null;
  }
};

export const fetchUserAvatar = async (userId: number): Promise<string> => {
  try {
    const response = await getContext().utils.api.fetch(
      `${API_URL}/users/${userId}/profile`
    );
    if (!response.ok) return DEFAULT_AVATAR;
    const json = await response.json();
    const photo = json?.response
      ?.flatMap(
        (card: { data?: { user?: { photo?: string } }[] }) => card.data ?? []
      )
      .find((item: { user?: { photo?: string } }) => item?.user?.photo)
      ?.user?.photo;
    return photo || DEFAULT_AVATAR;
  } catch {
    return DEFAULT_AVATAR;
  }
};
